import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import { filteredLimaSourcesAtom } from '@/pages/Administration/Devices/Devices.store';

import type { LimaSourcesResponseModal } from '../DevicesTable';

export const exportedCloudSourcesColumnSelectionAtom = atomWithStorage<
  string[]
>('CloudSourcesExportColumns', []);

export type CloudSourceExportDataModel = {
  DeviceID?: string;
  DeviceName?: string;
  SourceID?: string;
  Source: string;
  Site?: string;
  State?: string;
  IngestMethod?: string;
  LastSeen?: string;
  OrganizationCode: string;
  OrganizationName: string;
  Status: string;
  StatusUpdatedAt: string;
};

/**
 * Transforms a cloud source into the export data model
 * Extracted for testability and reusability
 */
export const transformToExportModel = (
  source: LimaSourcesResponseModal
): CloudSourceExportDataModel => ({
  DeviceID: source.device_uid,
  SourceID: source.source_uid,
  DeviceName: source.lima_devices?.host_name,
  Source: source.source_type?.name ?? '',
  Site: source.site_name ?? '',
  IngestMethod: source.ingest_method ?? '',
  LastSeen: source.last_seen ?? '',
  State: source.active ? 'Active' : 'Inactive',
  OrganizationCode: source.organization?.label ?? '',
  OrganizationName: source.organization?.name ?? '',
  Status: source.source_statuses?.[0]?.status_code_detail?.status_label ?? '',
  StatusUpdatedAt: source.source_statuses?.[0]?.status_updated_at ?? ''
});

export const cloudSourcesExportAtom = atom<CloudSourceExportDataModel[]>(
  (get) => {
    const cloudSources = get(filteredLimaSourcesAtom);
    return cloudSources.map(transformToExportModel);
  }
);
